module.exports = __webpack_public_path__ + "static/02.bcb39c84.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/gallery/02.png
// module id = 439
// module chunks = 35783957827783 172322841747965